import React from "react";
import { RecentSearchItem as RecentSearchItemType } from "../types";
import { SearchItem } from "./SearchItem";

interface RecentSearchItemProps {
  item: RecentSearchItemType;
  isSelected: boolean;
  onClick: () => void;
  onOpenInNewTab?: () => void;
}

export const RecentSearchItem = React.forwardRef<
  HTMLDivElement,
  RecentSearchItemProps
>(({ item, isSelected, onClick, onOpenInNewTab }, ref) => {
  return (
    <SearchItem
      ref={ref}
      item={item}
      isSelected={isSelected}
      onClick={onClick}
      onOpenInNewTab={onOpenInNewTab}
      variant="recent-search"
      data-test={`global-search-recent-item-${item.id}`}
    />
  );
});

RecentSearchItem.displayName = "RecentSearchItem";
